export default __webpack_public_path__ + "asset/img/wx-pop~72f9162c.png";